export enum CampaignStatus {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  SENDING = 'sending',
  SENT = 'sent',
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
}

export enum CampaignType {
  WEB_DEVELOPMENT = 'web_development',
  MOBILE_DEVELOPMENT = 'mobile_development',
  SAAS_DEVELOPMENT = 'saas_development',
  E_COMMERCE = 'e_commerce',
  STAFF_AUGMENTATION = 'staff_augmentation',
  CONSULTING = 'consulting',
  DESIGN_SERVICES = 'design_services',
  DEVOPS = 'devops',
  DATA_ANALYTICS = 'data_analytics',
  AI_ML = 'ai_ml',
  CUSTOM = 'custom',
}

export interface SendSettings {
  dailyLimit?: number;
  sendInterval?: number;
  businessHoursOnly?: boolean;
  startTime?: string;
  endTime?: string;
  timezone?: string;
  skipWeekends?: boolean;
}

export interface CampaignStats {
  totalEmails: number;
  emailsSent: number;
  emailsDelivered: number;
  emailsOpened: number;
  emailsClicked: number;
  emailsBounced: number;
  emailsReplied: number;
  openRate: number;
  clickRate: number;
  replyRate: number;
  bounceRate: number;
}

export interface Campaign {
  id: number;
  teamId: number;
  name: string;
  description?: string;
  campaignType: CampaignType;
  targetIndustries?: string[];
  templateId?: number;
  templateName?: string;
  status: CampaignStatus;
  targetLeadIds: number[];
  leadCount: number;
  sendSettings?: SendSettings;
  aiPersonalization: boolean;
  scheduledFor?: string;
  customSubject?: string;
  customContent?: string;
  createdBy: string;
  createdByName?: string;
  createdAt: string;
  updatedAt: string;
  stats?: CampaignStats;
}

export interface CreateCampaignData {
  name: string;
  description?: string;
  campaignType: CampaignType;
  targetIndustries?: string[];
  templateId?: number;
  targetLeadIds: number[];
  sendSettings?: SendSettings;
  aiPersonalization?: boolean;
  scheduledFor?: string;
  customSubject?: string;
  customContent?: string;
}

export interface CampaignFilters {
  page?: number;
  limit?: number;
  status?: CampaignStatus;
  search?: string;
  templateId?: number;
  createdBy?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface CampaignsResponse {
  campaigns: Campaign[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface GetMatchingLeadsData {
  campaignType: CampaignType;
  targetIndustries?: string[];
  minMatchScore?: number;
  limit?: number;
}

export interface MatchingLead {
  id: number;
  name: string;
  email: string;
  company: string;
  industry: string;
  jobTitle: string;
  tags: string[];
  notes?: string;
  matchScore: number;
  matchReasons: string[];
}